module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "h1",
    attrs: {
      "id": "Ack"
    }
  }, [_c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_vm._v("Acknowledgements")])]), _c('a', {
    attrs: {
      "id": "pg9"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many thanks to those who provided information, insight, moral support and/or otherwise contributed to this project. They include:")]), _vm._v(" "), _c('p', {
    staticClass: "hanga1"
  }, [_vm._v("Andy Yurkanin, for memories of the great restaurants and restaurateurs of the 1950s and ’60s")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Phil Wong and Christina Gee, for recollections of Trader Vic’s")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Stephanie Graham, for describing the Polynesia in 1967")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Paul Dorpat, Eric Lacitis and Jean Godden, for the use of images and quotations")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("John Nicon and the Greek-American Historical Museum of Washington State, for information about Greek restaurant owners and permission to quote from that organization’s website")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Sherri King, Bartell Drugs Archives")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Tony A. Johnson, chairman of the Chinook Indian Nation, for notes about oysters and the role the Chinook and Lower Chehalis tribes played in Washington’s early oyster industry")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Mary Henry, for insight into early black restaurant owners")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Scott Farrar, for information about the Coon Chicken Inns")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("The "), _c('i', [_vm._v("Seattle Times")]), _vm._v(", for permission to quote from articles")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Nat Lund, John Hinterberger, Everett Boss and other culinary critics of years gone by, for the stories they left us of meals enjoyed at restaurants that have long since disappeared")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Phil Stairs, Washington State Archives Puget Sound Regional Branch")])]), _c('p', {
    staticClass: "hanga"
  }, [_c('a', {
    attrs: {
      "id": "pg9"
    }
  }), _c('a', {
    attrs: {
      "id": "pg10"
    }
  }, [_vm._v("Carolyn Marr, Museum of History and Industry")])]), _c('a', {
    attrs: {
      "id": "pg10"
    }
  }, [_c('p', {
    staticClass: "hanga"
  }, [_vm._v("Jade D’Addario, Seattle Public Library")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Julie Irick, Seattle Municipal Archives")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Kris Kinsey, University of Washington Special Collections")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Laura Cooper, Ballard Historical Society")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Alicia Arter, Queen Anne Historical Society")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Lissa Kramer, Southwest Seattle Historical Society")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Vicki Stiles, Shoreline Historical Museum")]), _vm._v(" "), _c('p', {
    staticClass: "hanga"
  }, [_vm._v("Artie Crisp and Abigail Fleming, editors extraordinaire at The History Press")]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Images not individually credited are from my personal collection. Quotations not specifically attributed are from contemporary sources such as the "), _c('i', [_vm._v("Seattle Times")]), _vm._v(" and other early newspapers; business directories like Choir’s Pioneer Directory of the City of Seattle and King County; and vintage advertisements and menus.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A few caveats: the term “restaurant,” as used here, is purposefully broad. A restaurant can be anything from a hole-in-the-wall storefront to an upscale, elegant establishment in its own building. But restaurants weren’t (and aren’t) the only places to get a meal. From ancient times, inns and taverns have offered food along with lodging and drink. Over the years, a great variety of eateries—cafés, coffee houses, tearooms, grills, snack bars, lunch counters, diners, burger joints, hot dog stands, drive-ins and drive-ups—have sprung up to tempt appetites. There’s not necessarily a clear distinction between these terms; in fact, individual businesses often changed their names to accord with the latest trends. For instance, Bob’s Café at 101 Main Street, as it was known five years ago, might be called Jimmy’s Diner today. Come back five years later, and it’s the Main Street Grill.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It’s not going to be possible to name all of the restaurants that have come and gone in Seattle; if they were all included, you would need a forklift to pick up this book. It’s inevitable that someone’s favorite restaurant will not have been mentioned. The objective is to illustrate the breadth and depth of Seattle’s restaurant history with equal time given to downtown eateries and to those found in its neighborhoods and along its thoroughfares. Downtown may be the center of Seattle’s universe, but that hub is surrounded by a constellation of neighborhoods. Many of them were once independent towns, and all of them have restaurant histories of their own. In fact, by the 1920s, the sheer number of neighborhood eateries outpaced what was available downtown.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "pg10"
    }
  }), _c('a', {
    attrs: {
      "id": "pg11"
    }
  }, [_vm._v("Untangling the convoluted skein of Seattle restaurant ownership history, name and location changes and so on has been a challenge. The best efforts have been made to get things straight; if the intent hasn’t been met, it’s not for lack of trying.")])]), _c('a', {
    attrs: {
      "id": "pg11"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d9748952","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/05_acknowledgement.vue
// module id = 72
// module chunks = 0